/**
 * 模块级缓存管理器 - 在 React 组件外维护 iframe blob URL 和高度
 * 使 iframe 在虚拟化列表卸载/重挂载时能复用已有的 blob URL 和高度
 */

interface IframeCacheEntry {
  blobUrl: string
  height: number
  iframeId: string
  refCount: number
}

const cache = new Map<string, IframeCacheEntry>()

export function getOrCreateEntry(
  content: string,
  buildHtml: (iframeId: string) => string
): IframeCacheEntry {
  const existing = cache.get(content)
  if (existing) {
    existing.refCount++
    return existing
  }

  const iframeId = Math.random().toString(36).slice(2)
  const html = buildHtml(iframeId)
  const blob = new Blob([html], { type: 'text/html;charset=UTF-8' })
  const blobUrl = URL.createObjectURL(blob)

  const entry: IframeCacheEntry = {
    blobUrl,
    height: 50,
    iframeId,
    refCount: 1,
  }
  cache.set(content, entry)
  return entry
}

export function updateHeight(content: string, height: number): void {
  const entry = cache.get(content)
  if (entry) {
    entry.height = height
  }
}

export function releaseEntry(content: string): void {
  const entry = cache.get(content)
  if (entry) {
    entry.refCount--
    // 不立即销毁 blob URL，保留供重挂载复用
  }
}
